<template>
    <div class="enrollments">
        <div v-if="!loading">
            <p class="enrollment-title">Matrículas</p>
            <div class="card-enrollments" v-if="customerEnrollments.length">
                <div class="enrollment-selector">
                    <div :class="`enrollment-item ${selectedEnrollment == enrollment ? 'active' : ''}`" :key="enrollment" v-for="enrollment in Array.from(new Set(customerEnrollments))" v-on:click="selectEnrollment(enrollment)">{{ enrollment != 'null' ? enrollment : 'Nenhuma' }}</div>
                </div>
                <div class="card-info-row" v-if="benefitTypeName">
                    <div class="card-info">
                        <label for=""><b>Tipo de Benefício</b></label>
                        {{ benefitTypeName }}
                    </div>
                </div>
                <div class="card-info-row">
                    <div class="card-info">
                        <label for=""><b>Salário</b></label>
                        {{ jobSalary | fmtMoney }}
                    </div>
                </div>
                <div class="card-info-grid">
                    <div class="card-info">
                        <label for=""><b>Margem Empréstimo</b></label>
                        {{ job.margin30 | fmtMoney }}
                    </div>
                    <div class="card-info">
                        <label for=""><b>Margem Livre</b></label>
                        {{ job.margin30Free | fmtMoney }}
                    </div>
                    <div class="card-info">
                        <label for=""><b>Data</b></label>
                        {{ job.margin30FreeAt ? $moment(job.margin30FreeAt).format('DD/MM/YYYY') : "-" }}
                    </div>
                    <div class="card-info">
                        <label for=""><b>Fonte</b></label>
                        {{ job.margin30FreeOrigin ? job.margin30FreeOrigin == 'user' ? "Usuário" : "Portal" : "-" }}
                    </div>
                </div>
                <div class="card-info-grid">
                    <div class="card-info">
                        <label for=""><b>Margem Cartão</b></label>
                        {{ job.margin5 | fmtMoney }}
                    </div>
                    <div class="card-info">
                        <label for=""><b>Margem Livre</b></label>
                        {{ job.margin5Free | fmtMoney }}
                    </div>
                    <div class="card-info">
                        <label for=""><b>Data</b></label>
                        {{ job.margin5FreeAt ? $moment(job.margin5FreeAt).format('DD/MM/YYYY') : "-" }}
                    </div>
                    <div class="card-info">
                        <label for=""><b>Fonte</b></label>
                        {{ job.margin5FreeOrigin ? job.margin5FreeOrigin == 'user' ? "Usuário" : "Portal" : "-" }}
                    </div>
                </div>
            </div>
            <div class="card-enrollments-empty" v-else>
                <v-icon>fa-folder-open</v-icon>
                <h5>Cliente não possui benefício!</h5>
            </div>
        </div>
        <div class="card-enrollment-loading" v-else>
            <v-progress-circular
                :size="30"
                :width="4"
                color="blue"
                indeterminate
            ></v-progress-circular>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        jobs: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        customerEnrollments: {
            type: Array,
            required: true
        },
        selectEnrollment: {
            type: Function,
            required: true
        },
        selectedEnrollment: {
            type: String,
            required: false
        },
        benefitTypes: {
            type: Array,
            required: true
        },
    },

    watch: {
        async 'customerEnrollments'(newCustomerEnrollments) {
            if (newCustomerEnrollments.length) {
                this.selectEnrollment(newCustomerEnrollments[0]);
            }
        }
    },

    computed: {
        benefitTypeName() {
			if (this.benefitTypes && this.jobs && this.selectedEnrollment) {
				let job = this.jobs.find(el => el.enrollment === this.selectedEnrollment);
				if (job && job.benefitTypeId) {
					let b = this.benefitTypes.find(benefitType => benefitType.id === job.benefitTypeId);
					if (b) {
						return `${b.id} - ${b.name}`;
					}
				}
			}

			return null;
		},

        job() {
            if (this.jobs && this.jobs.length && this.selectedEnrollment) {
                return this.jobs.find(el => el.enrollment === this.selectedEnrollment);
            }

            return {};
        },

        jobSalary() {
			if (this.jobs && this.selectedEnrollment) {
				let job = this.jobs.find(el => el.enrollment === this.selectedEnrollment);
				if (job) {
					return job.salary || 0;
				}
			}

			return 0;
		},
    }
}
</script>

<style scoped>
    p {
        margin: 0;
    }

    .enrollment-title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
        color: grey;
    }
    .card-info {
        display: flex;
        flex-direction: column;
    }

    .card-info > label {
        font-size: 12px;
        color: var(--gray-color);
    }

    .card-info.avatar {
        flex-direction: row;
        align-items: center;
    }

    .card-info-row {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .card-info-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        align-items: flex-end;
        gap: 20px;
    }

    .card-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: var(--primary-color);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: bold;
        color: var(--white-color);
        margin-right: 10px;
    }

    .card-info span {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }

    .enrollments {
        width: 100%;
        display: flex;
        flex-direction: column;
        /* box-shadow: 0 5px 20px 0 rgba(0,0,0, 0.15); */
        padding: 15px;
        border-radius: 5px;
        background-color: var(--white-color);
        gap: 10px;
        grid-area: enrollments;
    }

    .card-enrollments {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .card-enrollments-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .card-enrollment-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .card-enrollments-empty > h5 {
        font-weight: bold;
        color: var(--warning-color);
    }
    
    .card-enrollments-empty > i {
        font-weight: bold;
        color: var(--warning-color);
    }

    .enrollment-selector {
        display: flex;
        flex-direction: row;
        gap: 10px;
        margin-bottom: 10px;
    }

    .enrollment-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 10px;
        background-color: var(--background-color);
        border-radius: 3px;
        cursor: pointer;
        transition: .2s;
        font-weight: bold;
    }

    .enrollment-item:hover, .enrollment-item.active {
        background-color: var(--secondary-color);
        color: var(--white-color);
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Cards/EnrollmentsCard.vue